import engine from "./engine";
const storeSegments = {
  engine,
};

export default storeSegments;
